<template>
  <div class="zan-loading">
  	<span class="zan-spinner"></span>
  </div>
</template>

<script>
export default {
  name: 'zan-loading'
};
</script>



// WEBPACK FOOTER //
// loading.vue?0f9775d5